/**
 * The Asset element's "Filter by asset class" setting, as the extra picker
 * context the asset picker sends: the preselected classes' ids and whether
 * only those exact classes count (otherwise their sub-classes do too). Fixed
 * at design time, never from the fill context. Empty when the filter is off
 * or no class is chosen, so the picker offers every asset as before.
 */
export function assetClassFilterArgs(
  data: Record<string, unknown> | null | undefined,
): { assetClassIds?: string[]; assetClassesExact?: boolean } {
  if (!data || data.filterByAssetClass !== true) return {};
  const picked = Array.isArray(data.fixedAssetClasses) ? data.fixedAssetClasses : [];
  const ids = picked
    .map((row) => (row && typeof row === "object" ? (row as { id?: unknown }).id : null))
    .filter((id): id is string | number => typeof id === "string" || typeof id === "number")
    .map(String);
  if (!ids.length) return {};
  return { assetClassIds: ids, assetClassesExact: data.assetClassesExact === true };
}
